import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { NavService } from '../services/nav.service';
import { AuthService} from '../auth/auth.service';
import { TranslatorService } from '../services/translate.service';


@Component({
  selector: 'app-transfer-receipts',
  templateUrl: './transfer-receipts.component.html',
  styleUrls: ['./transfer-receipts.component.scss']
})
export class TransferReceiptsComponent implements OnInit {
  ss:any;
  user:any;
  sended: boolean = false;
  transferReceiptsUrl: SafeResourceUrl;
  title = "Incassi Cessione";
  subTitle = "EDAC - Incassi Cessione";
  innerHeight: any;
  constructor(public navService: NavService, public translate: TranslatorService, private authService: AuthService) { }


  ngDoCheck() {

    if (this.sended == false) {
      var frame: HTMLIFrameElement = document.getElementById('TransferReceiptsIframe') as HTMLIFrameElement;
      if (frame != null) {
        this.sended = true;
        frame.contentWindow?.postMessage('sstorage', this.ss);
        this.transferReceiptsUrl = environment.rootTransferReceipts + this.user.sub;
      }
    }

  }

  loadLabels(){
    this.translate.get('SIDEBAR.Incassi Cessione').subscribe(res => {
      this.title = res;
      this.subTitle = "EDAC - " + res;
    })
  }

  ngOnInit(): void {
    this.ss = window.sessionStorage;
    this.user =  this.authService.user();
    console.log('send message to iframe %o',this.ss,this.user);
    this.loadLabels();
    this.navService.setTitle(this.title);
    this.navService.setSubTitle(this.subTitle);
this.navService.setWikiKey('NODEF');
    let actions : any;
    actions = [
    ];
    this.navService.setActions(actions);
    this.innerHeight = (window.innerHeight - 74) + 'px';
  }

}


